module.exports = __webpack_public_path__ + "img/map_2.0c6c4ea6.webp";